import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import {Switch, Route} from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import AccessControl from "../../pages/authorized/AccessControl";
import Dashboard from "../../pages/authorized/Dashboard";
import Report from "../../pages/authorized/Report";
import Assignment from "../../pages/authorized/Assignment";
import Submission from "../../pages/authorized/Submission";
import Chatbot from "../../pages/authorized/Chatbot";
import Team from "../../pages/authorized/Team";
import TeamData from "../../pages/authorized/Team/Data";
import UserData from "../../pages/authorized/User";

const Private = () => {

    return (
        <Switch>
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <PrivateRoute exact path="/assignment" component={Assignment} />
            <PrivateRoute exact path="/submission" component={Submission} />
            <PrivateRoute exact path="/report" component={Report} />
            <PrivateRoute exact path="/chatbot" component={Chatbot} />
            <PrivateRoute exact path="/access_control" component={AccessControl} />
            <PrivateRoute exact path="/team" component={Team} />
            <PrivateRoute exact path="/team/:id" component={TeamData} />
            <PrivateRoute exact path="/user/:id" component={UserData} />
            <Route component={PageError} />
        </Switch>
    )
};

export default Private;
